import {Component, OnInit} from '@angular/core';
import {AppService} from "../../services/app.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {Pager, UserSearch} from "../../interfaces/pager";
import {PageEvent} from "@angular/material/paginator";
import {MatTableDataSource} from "@angular/material/table";
import {HttpErrorResponse} from "@angular/common/http";
import {C2cEditComponent} from "./components/c2c-edit/c2c-edit.component";
import {DialogService} from "../../services/dialog.service";
import {CustomerDomainI} from '../../interfaces/customer-domain.interface';
import {Claim2CustomerI, ClaimI} from '../../interfaces/claim.interface';

@Component({
  selector: 'app-admin-page',
  templateUrl: './admin-page.component.html',
  styleUrls: ['./admin-page.component.scss']
})
export class AdminPageComponent implements OnInit {

  constructor(private app: AppService, private fb: FormBuilder, private dialog: DialogService,) {
  }

  usersDataSource = null;

  displayedColumns: string[] = [
    'email',
    'edit',
    'delete'
  ];

  pager: Pager = {
    length: null,
    pageSize: 10,
    pageIndex: 0,
    sortCol: null,
    sortOrder: null
  };

  pageSizeOptions: number[] = [5, 10, 25, 100];

  domains: string[] = [];
  claims: ClaimI[] = null;

  searchTimeout = null;

  searchForm: FormGroup = this.fb.group({
    'input': this.fb.control(''),
    'claim': this.fb.control(''),
    'domain': this.fb.control(''),
  });

  newUsers: { email: string, domain: string }[] = [
    {email: '', domain: ''}
  ]

  invitationForm: FormGroup = this.fb.group({
    users: this.fb.group({}),
    products: this.fb.group({})
  })

  customerDomains: CustomerDomainI[];

  domain_ids: string[] = [];
  domainUsers: Claim2CustomerI[] = [];

  productSelected = true;

  ngOnInit(): void {
    let customer_ids: string[] = [];
    this.app.getPermissions().then(() => {
      this.app.domainAdmins.forEach(c2u => {
        customer_ids.push(c2u.external_customer_id);
      })
      this.app.getAllCustomerDomains(customer_ids).then(domains => {
        this.customerDomains = domains;
        let domainNames = [];
        let claims: ClaimI[] = [];
        if (domains) {
          domains.forEach(d => {
            this.domain_ids.push(d.id);
            domainNames.push(...d.domains);
            claims.push(d.claim);
          })
        }
        this.domains = domainNames.filter((name, i, self) => self.indexOf(name) === i);
        claims = claims.filter((c, i, self) => self.indexOf(c) === i);
        this.initInvitationForm(claims);
        this.userFind();
      })
    })

    this.searchForm.valueChanges.subscribe(() => this.liveSearch())
  }

  initInvitationForm(claims: ClaimI[]) {
    if (this.newUsers) {
      let usersGroup = (this.invitationForm.get('users') as FormGroup);
      this.newUsers.forEach((u, i) => {
        usersGroup.addControl(i.toString(10), this.fb.group({
          'email': this.fb.control(u.email),
          'domain': this.fb.control(u.domain),
        }));
        usersGroup.get(i.toString(10)).valueChanges.subscribe(c => {
          this.newUsers[i].email = c.email;
          this.newUsers[i].domain = c.domain;
        });
      })
      this.claims = claims;
    }
    if (claims) {
      claims.forEach(c => {
        (this.invitationForm.get('products') as FormGroup).addControl(c.name, this.fb.control(claims.length === 1))
      });
      (this.invitationForm.get('products') as FormGroup).valueChanges.subscribe(change => {
        let selected = false;
        Object.values(change).map(v => {
          if(v) {
            selected = true;
          }
        })
        this.productSelected = selected;
      })
      this.claims = claims;
    }
  }

  addUser() {
    let newUser = {email: '', domain: ''};
    let i = this.newUsers.length;
    let usersGroup = (this.invitationForm.get('users') as FormGroup);
    usersGroup.addControl(i.toString(10), this.fb.group({
      'email': this.fb.control(newUser.email),
      'domain': this.fb.control(newUser.domain),
    }));
    this.newUsers.push(newUser);
  }

  removeUser(i: number) {
    this.newUsers.splice(i, 1);
    let usersGroup = (this.invitationForm.get('users') as FormGroup);
    usersGroup.removeControl(i.toString(10));
  }

  switchPage(e: PageEvent) {
    this.pager.pageIndex = e.pageIndex;
    this.pager.pageSize = e.pageSize;
    // console.log(e, this.pager);
    this.userFind();
  }

  liveSearch() {
    const values = this.searchForm.value;
    const inp = values.input;
    clearTimeout(this.searchTimeout);

    if (inp.length === 0 || inp.length > 3) {
      const params: UserSearch = {input: inp, domain: values.domain, claim: values.claim, domain_ids: this.domain_ids, pager: this.pager};

      this.searchTimeout = setTimeout(() => {
        console.log('live');
        this.userFind(params);
      }, 850);
    }
  }

  async userFind(params: UserSearch = null) {
    this.app.dialog.loader({
      title: 'Suche nach Benutzern'
    });

    if (!params) {
      params = {input: '', domain: '', claim: '', domain_ids: this.domain_ids, pager: this.pager};
    }

    this.app.getDomainUsers(params).then(res => {
      this.app.dialog.closeLoader();
      this.pager.length = res.total;
      this.domainUsers = res.found;
      this.usersDataSource = new MatTableDataSource(res.found);
    })
  }

  test() {
    console.log('test', this.app.user);
  }

  inviteUsers() {
    if (this.invitationForm.valid && this.productSelected) {
      this.app.dialog.loader({
        title: 'Benutzerzugang wird hinzugefügt'
      });

      let claims = this.invitationForm.get('products').value;
      let users = this.invitationForm.get('users').value;
      let newUsers: {email: string, domain: string}[] = Object.values(users)
      newUsers.forEach(u => {
        let email = `${u.email}@${u.domain}`;
        Object.keys(claims).map(key => {
          if (claims[key]) {
            this.app.claim2customer({claimName: key, email: email}).then(c2c => {
              this.app.toast.open('Benutzerzugang wurde hinzugefügt.');
              this.app.dialog.closeLoader();
              if (c2c?.id) {
                this.domainUsers.push(c2c);
                this.usersDataSource = new MatTableDataSource(this.domainUsers);
              }
            }).catch((e: HttpErrorResponse) => {
              this.app.dialog.closeLoader();
              let msg = e?.error?.error?.message || 'Unbekannter Fehler';
              this.app.toast.open(msg, null, {
                panelClass: 'warn'
              });
            })
          } else {
            this.app.dialog.closeLoader();
          }
        })
      })
    }
  }

  editUser(c2c) {
    const dialRef = this.dialog.open(C2cEditComponent, {data: c2c, width: '600px'});
    dialRef.afterClosed().subscribe(email => {

    })
  }

  deleteClaim2Customer(id: string, i: number) {
    this.app.deleteClaim2customer(id).then(res => {
      if (res) {
        const del = this.domainUsers.splice(i, 1);
        if (del) {
          this.usersDataSource = new MatTableDataSource(this.domainUsers);
        }
      }
    })
  }

  getClaimDesc(name) {
    return (this.claims.find(c => c.name === name))?.desc;
  }

}
